import { useEffect, useMemo, useRef, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";

// img
import { useNavigate, useParams } from "react-router-dom";
import { CLASSROOM_REPORTS, CLASSROOM_SERVICES } from "config/paths";
import { Formik } from "formik";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, getAge, getPdfBlob, successMessageToast, userFullName } from "helpers/common";
import { CLASSROOM_REPORT_V2_QUESTIONS, CLIENT_REPORT_TYPES, REPORT_IDS, reportDateFormat } from "config/constants";
import moment from "moment";
import ReportError from "components/shared/ReportsV2/ReportError";
import { useAssignedSchoolsDivisionLookupQuery, useDivisionLookupQuery, useLazyDivisionLookupQuery, useLazyTeacherLookupWithSchoolQuery, useUploadFileMutation } from "store/services/utility";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useSelector } from "react-redux";
import ViewPdfModal from "components/Modals/ViewPdfModal";
import { ArrowLeftIcon } from "Assets/icons";
import RenderQuestion from "components/shared/ReportsV2/Questions/Index";
import { formatReportFeedbackV2, reportInitialValuesV2 } from "helpers/assessment";
import QuestionMultipleObservation from "components/shared/ReportsV2/Questions/QuestionMultipleObservation";
import QuestionMultipleRecommendation from "components/shared/ReportsV2/Questions/QuestionMultipleRecommendation";
import { toPng } from "html-to-image";
import getValidationSchema from "./validation";
import { isEmpty } from "lodash";
import { useCreateClassroomReportCopyMutation, useGetAssessmentFeedbackQuery, useGetClassroomReportQuery, useSubmitClassroomReportMutation } from "store/services/clients/reports-v2/classroomReport";
import ClassroomConsultationPlanPdfDocV2 from "components/PDF/Clients/ReportsV2/ClassroomConsultationPlanPdfDocV2";
import AppInputField from "components/shared/FormComponents/AppInputField";
import ReportSubmitButton from "components/shared/ReportsV2/ReportSubmitButton";
import PdfPublishModal from "components/Modals/PdfPublishModal";
import { CommonSelect, CustomAsyncSelect } from "components/Common/Common";
import { Star } from "react-feather";
import { useFavouriteReportMutation } from "store/services/classroom";
import confirmDialogV2 from "utils/confirmationDialogV2";
import ClassroomReportDateModal from "components/Modals/ClassroomReportDateModalV2";
import AutosaveReport from "components/shared/ReportsV2/AutosaveReport";

const ClassroomReport = () => {
  const navigate = useNavigate();
  const sliderRefs = useRef([]);
  const [previewMode, setPreviewMode] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [pdfModal, setPdfModal] = useState(false)
  const [publishPdfModal, setPublishPdfModal] = useState(false)
  const [chartImages, setChartImages] = useState(null);
  const { reportId } = useParams();
  const assessmentId = 12
  const [document, setDocument] = useState(null)
  const [currentTab, setCurrentTab] = useState(1)
  const clientType = "school"
  const [teachers, setTeachers] = useState([])
  const [schools, setSchools] = useState([])
  const [divisionOptions, setDivisionOptions] = useState([])
  const [reportHeading, setReportHeading] = useState(CLIENT_REPORT_TYPES[REPORT_IDS.CLASSROOM_PLAN_V2]?.title);
  const [copyReportDateModal, setCopyReportDateModal] = useState(false)
  const [currentEntry, setCurrentEntry] = useState(null);

  const [submitReport, { isLoading: submitReportLoading }] = useSubmitClassroomReportMutation();
  const { data, isLoading, isFetching, isError, refetch } = useGetClassroomReportQuery({ assessmentId, reportId }, { skip: !reportId });
  const { data: schoolDivisonsList } = useAssignedSchoolsDivisionLookupQuery();
  const [teacherLookup, { data: teachersApiListing }] = useLazyTeacherLookupWithSchoolQuery()
  const [favouriteReport, { isLoading: favouriteReportLoading }] = useFavouriteReportMutation()
  const [copyReport, { isLoading: copyReportLoading }] = useCreateClassroomReportCopyMutation()
  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();

  const reportQuestions = data?.questions;
  const reportAnswers = data?.answers;
  const schoolDetails = data?.record?.reportsPreflightSchool;
  const teacherDetails = data?.record?.reportsPreflightTeacher;
  const coordinatorDetails = data?.record?.reportsPreflightCoordinate;


  const reportGoals = data?.assesmentData?.reportGoals;
  const reportRecommendations = data?.recommendation;
  const caseApprentice = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "apprentice");

  const chartRefs = useRef([]);

  const therapist = useSelector((state) => state?.auth?.user)

  const teachersList = useMemo(() => {

    const data = []

    const teacher = {
      id: teacherDetails?.id,
      lastname: teacherDetails?.lastname,
      firstname: teacherDetails?.firstname,
      email: teacherDetails?.email,
      role: "teacher"
    }
    const coordinator = {
      id: coordinatorDetails?.id,
      lastname: coordinatorDetails?.lastname,
      firstname: coordinatorDetails?.firstname,
      email: coordinatorDetails?.email,
      role: "teacher"
    }

    if (teacherDetails) {
      data.push(teacher)
    }

    if (coordinatorDetails) {
      data.push(coordinator)
    }
    return data
  }, [teacherDetails, coordinatorDetails]);

  const initialValues = useMemo(() => {
    if (!data) return {};
    const guardianList = data?.record?.classroomPlanGuardians?.map((item) => ({ id: item?.AssessmentReportGuardians?.id, role: item?.role }))
    let answers = reportAnswers;
    let values = {
      screening_date: data?.record?.screening_date || new Date(),
      apprentice_id: data?.assesment?.studentSignatureId,
      student: data?.assesment?.studentSignatureId ? { label: userFullName(caseApprentice?.caseTherapist), value: data?.assesment?.studentSignatureId } : null,
      signatureBy: data?.assesment?.signatureBy || null,
      guardianList,
      recommendation: data?.recommendation?.length ? data?.recommendation?.map((item) => ({ id: item?.id || null, answers: item?.answers, attachmentData: item?.attachmentData ? JSON.parse(item?.attachmentData) : [] })) : [],
      observations: data?.observation?.length ? data?.observation?.map((item) => ({ id: item?.id, notes: item?.notes || "", tracker_percentage: item?.tracker_percentage || 0, show_tracker: item?.show_tracker || "show", obs_date: item?.obs_date || null, strategy: item?.AssessmentObservationStrategy?.length ? item?.AssessmentObservationStrategy?.map((strategy) => ({ id: strategy?.id, template_id: strategy?.template_id, title: strategy?.TemplateDetail?.title || "", answers: strategy?.answers == "null" ? "" : strategy?.answers || "", attachmentData: strategy?.attachmentData ? JSON.parse(strategy?.attachmentData) : [] })) : [{ answers: "", attachmentData: [] }] })) : [{ notes: "", tracker_percentage: 0, show_tracker: "show", strategy: [{ answers: "", attachmentData: [] }] }],
      report_total_students: data?.record?.report_total_students,
      report_classname: data?.record?.report_classname,
      report_grade: data?.record?.report_grade,
      report_age_range: data?.record?.report_age_range,
      emailFormData: {
        pdfPassword: ""
      },
      school_division: data?.record?.school_division ? { label: data?.record?.reportsPreflightSchoolDivision?.title, value: data?.record?.school_division } : "",
      school: data?.record?.school ? { label: data?.record?.reportsPreflightSchool?.name, value: data?.record?.school } : "",
      teacher: data?.record?.reportsPreflightTeacher?.id ? { label: userFullName(data?.record?.reportsPreflightTeacher), value: data?.record?.reportsPreflightTeacher?.id } : "",
      coordinator: data?.record?.reportsPreflightCoordinate?.id ? { label: userFullName(data?.record?.reportsPreflightCoordinate), value: data?.record?.reportsPreflightCoordinate?.id } : "",
    };

    values = reportInitialValuesV2(values, reportQuestions, answers);

    return values;
  }, [data]);


  const validationSchema = useMemo(() => {
    return getValidationSchema(currentTab, reportQuestions)
  }, [reportQuestions, currentTab]);

  const handleSubmitStep = async (values) => {
    setSubmitting(true);

    const selectedGuardians = teachersApiListing?.records?.map((guardian) => {
      const id = guardian?.client_guardian?.id;

      const matchedGuardian = values?.guardianList?.find(
        (item) => item.id === id
      );

      if (matchedGuardian) {
        return {
          ...guardian,
          key: matchedGuardian.role,
        };
      }

      return null;
    })
      .filter(Boolean);

    try {
      let payload = formatReportFeedbackV2(reportHeading, reportQuestions, { ...values });

      let body = {
        goals: [],
        assesment_location: "in-person",
        feedbacks: payload.feedbacks,
        screening_date: values?.screening_date,
        report_heading: reportHeading,
        guardianList: values?.guardianList,
        recommendation: values?.recommendation,
        signatureBy: values?.signatureBy,
        observations: values?.observations,
        report_classname: values?.report_classname,
        report_age_range: values?.report_age_range,
        report_grade: values?.report_grade,
        report_total_students: values?.report_total_students,
        school: values?.school?.value,
        school_division: values?.school_division?.value,
        teacher_id: values?.teacher?.value,
        coordinator_id: values?.coordinator?.value

      };

      // save chart images for later use
      if (currentTab == 3 && !values?.isAutoSave) {
        const sliderImages = await getSliderImages();
        console.log('sliderImages', sliderImages)
        if (sliderImages) {
          setChartImages(sliderImages);
        }
      }

      if (therapist?.role_type == "apprentice" || values?.saveForLater) {
        body = {
          ...body,
          studentSignatureId: values?.apprentice_id,
          save_for_later: "yes",
        }
      }
      else {
        const pdfData = {
          clientId: data?.id,
          lastname: data?.lastname,
          firstname: data?.firstname,
          city_town: data?.client_detail?.city_town,
          dob: dateFormat(data?.client_detail?.dob),
          age: getAge(data?.client_detail?.dob),
          grade: data?.client_detail?.report_grade,
          schoolName: data?.record?.reportsPreflightSchool?.name,
          schoolLocation: data?.record?.reportsPreflightSchool?.location,
          screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
          selectedGuardians: selectedGuardians || [],
          reportHeading,
          therapist,
          apprentice: values?.apprentice_id,
          caseApprentice,
          therapistSignature: therapist?.signature_img,
          emailSignature: therapist?.email_signature,
          reportDate: moment(new Date()).format(reportDateFormat),
          reportQuestions,
          reportAnswers,
          assessmentGoals: reportGoals,
          images: chartImages,
          observations: values?.observations,
          recommendation: values?.recommendation,
          report_classname: values?.report_classname,
          report_age_range: values?.report_age_range,
          report_grade: values?.report_grade,
          report_total_students: values?.report_total_students,
          teacherId: data?.record?.teacher_id,
          teacher: data?.record?.reportsPreflightTeacher,
        }

        const doc = (
          <ClassroomConsultationPlanPdfDocV2
            data={pdfData}
          />
        )

        // setDocument(doc)

        const filename = `Classroom Consultation Plan - ${moment(new Date()).format("YYYY-MM-DD")}.pdf`
        let pdfFile = await getPdfBlob(doc, false, filename);

        let uploadedFileName = await uploadFile({ file: pdfFile, acl: "private", fileOriginalFormat: true }).unwrap();

        if (!uploadedFileName) {
          throw new Error("File not uploaded");
        };


        body = {
          ...body,
          pdfData: [{
            attachment_key: uploadedFileName,
            attachment_name: "Classroom Consultation Report",
          }],
          emailFormData: values?.emailFormData,
          current_step: "submit_and_email",
        }
      }

      const response = await submitReport({ data: body, reportId }).unwrap()
      setSubmitting(false);
      if (!values?.isAutoSave) {
        successMessageToast(response.message)
      }
      if (!values?.saveForLater) {
        navigate(CLASSROOM_REPORTS)
      }
      else {
        refetch()
      }
    } catch (error) {
      setSubmitting(false);
      console.log('error', error)
    }
  };
  const handleViewPdf = async (values) => {

    const selectedGuardians = teachersApiListing?.records?.map((guardian) => {
      const id = guardian?.client_guardian?.id;

      const matchedGuardian = values?.guardianList?.find(
        (item) => item.id === id
      );

      if (matchedGuardian) {
        return {
          ...guardian,
          key: matchedGuardian.role,
        };
      }

      return null;
    })
      .filter(Boolean); // remove null entries

    const pdfData = {
      clientId: data?.id,
      lastname: data?.lastname,
      firstname: data?.firstname,
      city_town: data?.client_detail?.city_town,
      dob: dateFormat(data?.client_detail?.dob),
      age: getAge(data?.client_detail?.dob),
      grade: data?.client_detail?.report_grade,
      schoolName: data?.record?.reportsPreflightSchool?.name,
      schoolLocation: data?.record?.reportsPreflightSchool?.location,
      screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
      selectedGuardians: selectedGuardians || [],
      reportHeading,
      therapist,
      apprentice: values?.apprentice_id,
      caseApprentice,
      therapistSignature: therapist?.signature_img,
      emailSignature: therapist?.email_signature,
      reportDate: moment(new Date()).format("MMMM D, YYYY"),
      reportQuestions,
      reportAnswers,
      assessmentGoals: reportGoals,
      images: chartImages,
      observations: values?.observations,
      recommendation: values?.recommendation,
      report_classname: values?.report_classname,
      report_age_range: values?.report_age_range,
      report_grade: values?.report_grade,
      report_total_students: values?.report_total_students,
      teacherId: data?.record?.teacher_id,
      teacher: data?.record?.reportsPreflightTeacher,
    }

    const doc = (
      <ClassroomConsultationPlanPdfDocV2
        data={pdfData}
      />
    )

    setDocument(doc)
    setPdfModal(true)

  };

  const getSliderImages = async () => {
    if (!sliderRefs.current?.length) return null;

    return await Promise.all(
      sliderRefs.current.map(async (ref) => {
        if (ref) {
          try {
            return await toPng(ref, { pixelRatio: 2 });
          } catch (error) {
            console.error('Error generating slider image:', error);
            return null;
          }
        }
        return null;
      })
    );
  };

  const getTeachers = async (schoolId) => {
    try {
      const result = await teacherLookup(schoolId).unwrap()
      console.log('result', result)
      const teacherOptions = result?.records?.map((item) => ({ label: userFullName(item?.client_guardian), value: item?.client_guardian?.id }))
      setTeachers(teacherOptions)
    } catch (error) {
      console.log('error getting teachers', error)
    }

  }

  const handleDivisionSelect = (selected, setFieldValue) => {
    // setFieldValue("schoolDivision", selected)
    setFieldValue("schoolName", "")
    setFieldValue("teacher", "")
    setFieldValue("coordinator", "")
    const division = schoolDivisonsList?.find((item) => item?.id == selected?.value)
    const schoolList = division?.schools?.map((item) => ({ label: item?.name, value: item?.id }))
    setSchools(schoolList)
  }

  const handleSchoolChange = (selected, setFieldValue) => {
    setFieldValue("schoolName", selected)
    setFieldValue("teacher", "")
    setFieldValue("coordinator", "")
    getTeachers(selected?.value)
  }

  const handleFavouriteReport = async (report_id, favourite) => {
    const data = {
      report_id,
      favorite: favourite
    }
    try {
      await favouriteReport({ data }).unwrap()
      refetch()
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleCopyReport = async (e, reportId) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "MAKE A COPY",
      message: `A copy of this report will be added to your list with ${moment().format(reportDateFormat)} as the Report Date.`,
    });
    if (!isConfirm) {
      setCopyReportDateModal(true)
      return
    }
    else {
      handleCopyReportApi(reportId, moment(new Date()).format("YYYY-MM-DD"))
    }
  }

  const handleCopyReportApi = async (reportId, screening_date) => {
    try {
      await copyReport({ assessmentId, reportId, screening_date }).unwrap()
      if (copyReportDateModal) {
        setCopyReportDateModal(false)
      }
      navigate(CLASSROOM_REPORTS)
    } catch (error) {
      console.log('error making copy of report', error)
    }
  }


  useEffect(() => {
    if (schoolDivisonsList) {
      const options = schoolDivisonsList?.map((item) => ({ label: item?.title, value: item?.id }))
      setDivisionOptions(options)
    }
  }, [schoolDivisonsList])

  useEffect(() => {
    if (data?.record?.school_division && schoolDivisonsList) {
      const division = schoolDivisonsList?.find((item) => item?.id == data?.record?.school_division)
      const schoolList = division?.schools?.map((item) => ({ label: item?.name, value: item?.id }))
      setSchools(schoolList)
    }

    if (data?.record?.school) {
      getTeachers(data?.record?.school)
    }
  }, [data, schoolDivisonsList])

  return (
    <>
      {/* <PDFDocViewer doc={<ConsultationReportPdfDocV2 />} /> */}
      {/* <Row>
        <Col lg="6">
          <img style={{width: "100%"}} src={example?.[0]} alt="hhfiufufuf" />
        </Col>
      </Row> */}
      <ClassroomReportDateModal
        show={copyReportDateModal}
        setShow={setCopyReportDateModal}
        currentEntry={currentEntry}
        handleCopyReportApi={handleCopyReportApi}
      />
      <section className="ReportSec proxima container-discharge-screen py-3 position-relative">
        <Container fluid>
          <div style={{ maxWidth: "80%", margin: "0 auto" }}>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmitStep}
              validationSchema={validationSchema}
              enableReinitialize
            >
              {({ handleSubmit, values, errors, touched, setFieldValue, submitForm, validateForm }) => (
                <Form onSubmit={handleSubmit}>
                  {isLoading ? (
                    <LoadingIndicator />
                  ) : isError ? (
                    <ErrorComponent />
                  ) : (
                    <>
                      {console.log("FORMIK VALUES ", values)}
                      {console.log("ERROR oF VALIDATION ", touched, errors)}

                      <ViewPdfModal
                        publishPdfCheckbox={true}
                        isPopup={true}
                        show={pdfModal}
                        setShow={setPdfModal}
                        doc={document}
                        handleSubmit={() => {
                          setFieldValue("saveForLater", false);
                          submitForm();
                        }}
                        clientType={clientType}
                        isClassroom={true}
                        guardianList={teachersList}
                      />
                      <PdfPublishModal
                        publishPdfCheckbox={true}
                        show={publishPdfModal}
                        setShow={setPublishPdfModal}
                        clientType={clientType}
                        doc={document}
                        handleSubmit={submitForm}
                        guardianList={teachersList}
                        isClassroom={true}
                      />
                      <AutosaveReport
                        delay={120000}
                        onAutosave={handleSubmitStep}
                        isFetching={isFetching}
                        ignoreFields={["goals"]}
                      >
                        <Row>
                          <Col lg="12" className="my-2">
                            <div className="bg-white session-report" style={{ overflow: "hidden", }}>
                              <>
                                {(isFetching || submitting || favouriteReportLoading || copyReportLoading) && <LoadingOverlay />}

                                <div className="formBody reports-v2 pt-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      <h5 className="section-title mb-0 border-0" style={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px" }}>{therapist?.therapist_discipline?.name}</h5>
                                      <p style={{ fontSize: "20px", marginTop: "5px", color: "#000" }}>
                                        <div className="d-flex align-items-center gap-2">
                                          <div className="cursor-pointer" onClick={() => { handleFavouriteReport(data?.record?.id, data?.record?.is_favorite ? 0 : 1) }}>{data?.record?.is_favorite ? <Star fill="#93278F" stroke="#93278F" /> : <Star />}
                                          </div>
                                          <div>Classroom Plan</div>
                                        </div>
                                      </p>
                                    </div>
                                    {
                                      currentTab == 4 && <button
                                        onClick={(e) => { handleCopyReport(e, data?.record?.id); setCurrentEntry(data?.record) }}
                                        type="button"
                                        className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        disabled={isFetching || submitting || copyReportLoading}
                                      // isLoading={submitReportLoading || submitting}
                                      >
                                        Make a Copy
                                      </button>
                                    }
                                  </div>
                                  <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
                                    <div className="d-flex align-items-center gap_20">
                                      <div style={{ width: "145px" }}>
                                        <label style={{ fontSize: '14px', color: "#000" }} className="discharge-screen-label mb-1">DATE OF REPORT</label>
                                        <AppDatePicker
                                          name="screening_date"
                                          className="w-100 py-2"
                                          disabled={previewMode}
                                        />
                                      </div>
                                      {
                                        [2, 3, 4].includes(currentTab) && (
                                          <div className="mt-1" style={{ width: "100%" }}>
                                            <div className="date-title d-flex justify-content-between">
                                              <h6 className="mb-0" style={{ marginTop: "3px" }}>CLASSROOM INFORMATION</h6>
                                              <div className="d-flex align-items-center gap-2">
                                                <label style={{ fontSize: '10px' }} className="discharge-screen-label mb-0 text-dark">TEACHER </label>
                                                <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{userFullName(data?.record?.reportsPreflightTeacher)}</p>
                                              </div>
                                            </div>
                                            <div className="d-flex flex-wrap gap-3 text-dark align-items-center justify-content-between">
                                              <div className="d-flex text-dark align-items-center gap-5">
                                                <div>
                                                  <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>SCHOOL</h5>
                                                  <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{data?.record?.reportsPreflightSchool?.name || "--"}</p>
                                                </div>
                                                <div>
                                                  <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CITY/TOWN</h5>
                                                  <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{data?.record?.reportsPreflightSchool?.location || "--"}</p>
                                                </div>
                                              </div>

                                              <div className="d-flex text-dark align-items-center gap-4">
                                                <div>
                                                  <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CLASS NAME</h5>
                                                  <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px" }}>{data?.record?.report_classname || "--"}</p>
                                                </div>
                                                <div>
                                                  <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}># OF STUDENTS</h5>
                                                  <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px" }}>{data?.record?.report_total_students || "0"}</p>
                                                </div>
                                                <div>
                                                  <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>GRADE</h5>
                                                  <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px" }}>{data?.record?.report_grade}</p>
                                                </div>
                                                <div>
                                                  <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>AGE RANGE</h5>
                                                  <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px" }}>{data?.record?.report_age_range || "--"}</p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      }
                                    </div>
                                  </div>
                                  <Row className="proxima-regular" style={{ fontSize: "11px", fontWeight: 500 }}>
                                    <Col lg="3" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 1 ? "#3DA0AA" : "#315D99", borderRadius: "3px", color: "white", textAlign: 'center' }}>CLIENT INFO</div>
                                      <div className={`${currentTab == 1 ? "arrow-right-tab-active" : "arrow-right-tab-previous"} position-relative`}></div>
                                      {/* <div className="arrow-right-tab-white position-relative"></div> */}
                                    </Col>
                                    <Col lg="3" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 2 ? "#3DA0AA" : (currentTab == 3 || currentTab == 4) ? "#315D99" : "#D9E8FE", borderRadius: "3px", color: (currentTab == 3 || currentTab == 2 || currentTab == 4) ? "white" : "#315D99", textAlign: 'center' }}>BACKGROUND</div>
                                      <div className={`${currentTab == 2 ? "arrow-right-tab-active" : (currentTab == 3 || currentTab == 4) ? "arrow-right-tab-previous" : "arrow-right-tab"} position-relative`}></div>
                                      <div className="arrow-right-tab-white position-relative"></div>
                                    </Col>
                                    <Col lg="3" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 3 ? "#3DA0AA" : currentTab == 4 ? "#315D99" : "#D9E8FE", borderRadius: "3px", color: (currentTab == 3 || currentTab == 4) ? "white" : "#315D99", textAlign: 'center' }}>OBSERVATIONS</div>
                                      <div className={`${currentTab == 3 ? "arrow-right-tab-active" : currentTab == 4 ? "arrow-right-tab-previous" : "arrow-right-tab"} position-relative`}></div>
                                      <div className="arrow-right-tab-white position-relative"></div>
                                    </Col>
                                    <Col lg="3" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 4 ? "#3DA0AA" : "#D9E8FE", borderRadius: "3px", textAlign: 'center', color: currentTab == 4 ? "white" : '#315D99' }}>RECOMMENDATIONS</div>
                                      {/* <div className={`${currentTab == 3 ? "arrow-right-tab-active" : "arrow-right-tab"} position-relative`}></div> */}
                                      <div className="arrow-right-tab-white position-relative"></div>
                                    </Col>
                                  </Row>
                                  {currentTab === 1 ? (
                                    <>
                                      <div
                                        className="mt-4 occupational-therapist-consulaion client-view"
                                      >
                                        <h5 className="section-title mt-2">1. SCHOOL INFORMATION</h5>
                                        <div className="mb-3 d-flex align-items-center gap_20">
                                          <div style={{ width: "33%" }}>
                                            <label className="discharge-screen-label">School Division</label>
                                            {/* <input className="readonly-box" readOnly value={schoolDetails?.location} /> */}
                                            <CommonSelect
                                              name={"school_division"}
                                              options={divisionOptions}
                                              isClearable
                                              placeholder={"(no division selected)"}
                                              // isLoading={getClientsLoading || getClientsFetching}
                                              onChange={(selected) => handleDivisionSelect(selected, setFieldValue)}
                                            // isDisabled={editMode}

                                            />
                                            {/* <div className="readonly-box">{data?.client_detail?.client_school_detail?.client_school?.location}</div> */}
                                          </div>
                                          <div style={{ width: "33%" }}>
                                            <label className="discharge-screen-label">School Name</label>
                                            {/* <div className="readonly-box">{data?.client_detail?.client_school_detail?.client_school?.name}</div> */}
                                            {/* <input className="readonly-box" readOnly value={schoolDetails?.name} /> */}
                                            <CommonSelect
                                              name={"school"}
                                              isClearable
                                              option={schools}
                                              placeholder={"(Select School)"}
                                              // isLoading={getClientsLoading || getClientsFetching}
                                              onChange={(selected) => handleSchoolChange(selected, setFieldValue)}
                                            // isDisabled={editMode}

                                            />
                                          </div>
                                        </div>

                                        {
                                          [0, 1]?.map((item, index) => (
                                            <div style={{ width: "68%" }} className="d-flex reports-guardian discharge-title gap-2">
                                              <input
                                                type="checkbox"
                                                className="form-check"
                                                style={{ accentColor: "#b46c9f", height: 20, width: 20, marginTop: "-3px" }}
                                                disabled={!values?.[index == 0 ? "teacher" : "coordinator"]}
                                                onChange={(e) => {
                                                  const isChecked = e.target.checked;
                                                  const teacherType = index == 0 ? "teacher" : "coordinator"
                                                  const guardianData = { id: values?.[teacherType]?.value, role: teacherType };

                                                  const currentList = values?.guardianList || [];

                                                  let updatedList;
                                                  if (isChecked) {
                                                    updatedList = [...currentList, guardianData];
                                                  } else {
                                                    updatedList = currentList.filter((item) => item.id !== values?.[teacherType]?.value);
                                                  }

                                                  setFieldValue('guardianList', updatedList);
                                                }}
                                                checked={values.guardianList?.some((item) => item.id === values?.[index == 0 ? "teacher" : "coordinator"]?.value)}
                                              />
                                              <div className="w-100">
                                                <div className="discharge-screen-label" style={{ textTransform: "uppercase", borderBottom: "none" }}>
                                                  {/* {slug == 'parent' ? title : index === 0 ? title : "Coordinator"} */}
                                                  {index == 0 ? "TEACHER" : "COORDINATOR"}
                                                </div>
                                                <div className="mb-3 mt-2 d-flex align-items-center" style={{ gap: "20px" }}>
                                                  <div className="w-100">
                                                    <CommonSelect
                                                      name={index == 0 ? "teacher" : "coordinator"}
                                                      option={teachers}
                                                      placeholder={`(Select ${index == 0 ? "teacher" : "coordinator"} )`}
                                                      isClearable
                                                      onChange={() => {
                                                        const teacherType = index == 0 ? "teacher" : "coordinator"
                                                        const val = values?.guardianList?.find((item) => item?.role !== teacherType)
                                                        console.log('val of yyy', val)
                                                        if (val) {
                                                          setFieldValue('guardianList', [val])
                                                        }
                                                        else {
                                                          setFieldValue('guardianList', [])
                                                        }
                                                      }}
                                                    // isLoading={getClientsLoading || getClientsFetching}
                                                    // onChange={(selected) => handleSchoolChange(selected, setFieldValue)}
                                                    // isDisabled={editMode}

                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ))
                                        }

                                      </div>
                                      <div
                                        className="mt-4 client-view classroom-info"
                                      >
                                        <h5 className="section-title mt-5">2. CLASSROOM INFORMATION</h5>
                                        <div className="mb-3 d-flex align-items-center gap_20">
                                          <div style={{ width: "10%" }}>
                                            <label className="discharge-screen-label">Class Name</label>
                                            <AppInputField className="readonly-box" type="text" name="report_classname" />
                                            {/* <div className="readonly-box">{data?.client_detail?.client_school_detail?.client_school?.location}</div> */}
                                          </div>
                                          <div style={{ width: "15%" }}>
                                            <label className="discharge-screen-label"># of Students</label>
                                            <AppInputField min={0} className="readonly-box" type="number" name="report_total_students" />
                                          </div>
                                          <div style={{ width: "8%" }}>
                                            <label className="discharge-screen-label">Grade</label>
                                            <AppInputField className="readonly-box" type="text" name="report_grade" />
                                          </div>
                                          <div style={{ width: "10%" }}>
                                            <label className="discharge-screen-label">Age Range</label>
                                            <AppInputField className="readonly-box" type="text" name="report_age_range" />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) :
                                    currentTab === 2 ? (
                                      <div
                                        className="mt-1 session-info teacher-concern"
                                      >
                                        <div style={{ backgroundColor: "#93278F1A", borderRadius: "12px", marginTop: "11px" }}>
                                          <p className="section-title text-center" style={{ border: 0, fontSize: "14px", fontStyle: "italic", padding: "19px" }}>Do not include any identifying information <span style={{ fontWeight: 400 }}> of individual students in this report.</span></p>
                                        </div>
                                        {reportQuestions?.length > 0 &&
                                          reportQuestions?.map((question, index) => {
                                            if (
                                              [
                                                CLASSROOM_REPORT_V2_QUESTIONS.teacher_concerns,
                                                CLASSROOM_REPORT_V2_QUESTIONS.classroom_information
                                              ].includes(question.id)
                                            ) {
                                              return (
                                                <div className={`py-4 ${index == 0 ? 'pt-2' : ''}`}>
                                                  <RenderQuestion
                                                    key={index}
                                                    question={question}
                                                    fieldName={question.id}
                                                    questionIndex={index + 1}
                                                  />
                                                </div>
                                              );
                                            }
                                          })}

                                        {/* <div className="goals-tracking">
                                      <GoalsTracking
                                        onSubmit={() => console.log("Submit")}
                                        // onNavigateBack
                                        clientType={clientType}
                                        chartRefs={chartRefs}
                                        formRefs={formRefs}
                                        error={goalSubmissionError}
                                        data={data}
                                        refetch={refetch}
                                      />
                                    </div> */}
                                      </div>
                                    ) :
                                      currentTab === 3 ? (
                                        <div className="recommendations">
                                          <h6 className="section-title w-100" style={{ marginBottom: "1px", marginTop: "24px" }}>
                                            OBSERVATIONS
                                          </h6>
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (question.id !== CLASSROOM_REPORT_V2_QUESTIONS.observation) return;
                                              return (
                                                <div className="pb-4">
                                                  {/* <RenderQuestion
                                                  key={index}
                                                  question={question}
                                                  fieldName={question.id}
                                                  questionIndex={1}
                                                  clientType={"school"}
                                                  assessmentId={assessmentId}
                                                /> */}
                                                  <QuestionMultipleObservation
                                                    sliderRefs={sliderRefs}
                                                    chartRefs={chartRefs}
                                                    key={index}
                                                    question={question}
                                                    fieldName={question.id}
                                                    questionIndex={1}
                                                    clientType={"classroom"}
                                                    assessmentId={assessmentId}
                                                  />
                                                </div>
                                              );
                                            }
                                            )}
                                          {
                                            touched.observations && errors.observations ? (
                                              <div className="text-danger">{typeof (errors.observations) == "string" && errors.observations}</div>
                                            ) : null
                                          }
                                        </div>
                                      ) : (
                                        <div className="recommendations">
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (question.id !== CLASSROOM_REPORT_V2_QUESTIONS.multiRecommendation) return;
                                              return (
                                                <div className="py-4">
                                                  {(
                                                    <h6 className="section-title w-100" style={{ marginBottom: "7px" }}>
                                                      {!isNaN(1) && `${1}. `}
                                                      {question?.question}
                                                    </h6>
                                                  )}
                                                  <QuestionMultipleRecommendation
                                                    key={index}
                                                    question={question}
                                                    fieldName={question.id}
                                                    fieldData={reportRecommendations}
                                                    questionIndex={1}
                                                    maxRecommendations={4}
                                                    clientType={"school"}
                                                    assessmentId={assessmentId}
                                                  />
                                                </div>
                                              );
                                            }
                                            )}
                                        </div>
                                      )
                                  }
                                </div>
                              </>
                            </div>
                          </Col>
                          <Col lg="12" className="my-2">
                            <ReportError />
                            <div className='d-flex gap-3 align-items-center justify-content-between'>
                              <div>
                                {currentTab > 1 && (
                                  <button
                                    onClick={() => setCurrentTab(currentTab - 1)}
                                    type="button"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    disabled={isFetching || submitting}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    <ArrowLeftIcon />
                                    {"Back"}
                                  </button>
                                )}
                              </div>
                              <div className="d-flex gap-3 align-items-center justify-content-between">
                                <ReportSubmitButton
                                  onClick={() => setFieldValue('saveForLater', true)}
                                  type="submit"
                                  className="d-flex gap-2 align-items-center justify-content-center save-discharge-screen"
                                  disabled={previewMode || isFetching || submitting}
                                // isLoading={submitReportLoading || submitting}
                                >
                                  Save
                                  {/* {<img width={13} height={6} src={down_arrow_img} alt="down_arrow_img" />} */}
                                  <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.939684 1.3674L6.16086 6.18695C6.35239 6.36374 6.64761 6.36375 6.83914 6.18695L12.0603 1.3674C12.3948 1.05868 12.1763 0.500001 11.7212 0.500001L1.27883 0.5C0.82367 0.5 0.605235 1.05868 0.939684 1.3674Z" fill="white" />
                                  </svg>
                                </ReportSubmitButton>
                                {currentTab === 4 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="d-flex align-items-center gap-2 justify-content-center preview-discharge-screen"
                                      // isLoading={submittingStep}
                                      disabled={isFetching || submitting}
                                      onClick={() => handleViewPdf(values)}
                                    >
                                      {/* <img width={16} height={14} src={preview_img} alt="preview_img" /> */}
                                      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.777778C0 0.571498 0.0842854 0.373667 0.234315 0.227806C0.384344 0.0819442 0.587827 0 0.8 0H15.2C15.4122 0 15.6157 0.0819442 15.7657 0.227806C15.9157 0.373667 16 0.571498 16 0.777778V13.2222C16 13.4285 15.9157 13.6263 15.7657 13.7722C15.6157 13.9181 15.4122 14 15.2 14H0.8C0.587827 14 0.384344 13.9181 0.234315 13.7722C0.0842854 13.6263 0 13.4285 0 13.2222V0.777778ZM1.6 1.55556V12.4444H14.4V1.55556H1.6ZM3.2 3.11111H4.8V4.66667H3.2V3.11111ZM4.8 6.22222H3.2V7.77778H4.8V6.22222ZM3.2 9.33333H4.8V10.8889H3.2V9.33333ZM12.8 3.11111H6.4V4.66667H12.8V3.11111ZM6.4 9.33333H12.8V10.8889H6.4V9.33333ZM12.8 6.22222H6.4V7.77778H12.8V6.22222Z" fill="white" />
                                      </svg>
                                      Preview Report
                                    </button>
                                    {
                                      therapist?.role_type == "veteran" &&
                                      <ReportSubmitButton
                                        // onClick={() => setFieldValue('saveForLater', false)}
                                        onClick={() => { setFieldValue('saveForLater', false); setPublishPdfModal(true) }}
                                        type="button"
                                        className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        disabled={isFetching || submitting}
                                      // isLoading={submitReportLoading || submitting}
                                      >
                                        SUBMIT
                                        {/* <img width={14} height={8} src={arro_right_img} alt="arro_right_img" /> */}
                                      </ReportSubmitButton>
                                    }
                                  </>
                                ) : (
                                  <button
                                    onClick={async () => {
                                      const errors = await validateForm();
                                      if (isEmpty(errors)) {
                                        setFieldValue('saveForLater', true);
                                        await submitForm();
                                        setCurrentTab(currentTab + 1);
                                      }
                                    }}
                                    type="submit"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    disabled={isFetching || submitting}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    Next
                                    {/* <img width={14} height={8} src={arro_right_img} alt="arro_right_img" /> */}
                                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.68197 3.24568L8.85675 0.5H10.2193L14 4.29259V4.70741L10.2193 8.5H8.85675L9.68197 5.75432H0V3.24568H9.68197Z" fill="white" />
                                    </svg>
                                  </button>
                                )}
                                {/* {
                                data?.assesment?.status != 'submitted'
                                &&
                                <>
                                  {
                                    therapist?.role_type == "veteran" &&
                                    <ReportSubmitButton
                                      onClick={() => setFieldValue('saveForLater', false)}
                                      type="submit"
                                      className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                      disabled={previewMode || isFetching || submitting}
                                    >
                                      SUBMIT & Export
                                      <img width={14} height={8} src={arro_right_img} alt="arro_right_img" />
                                    </ReportSubmitButton>
                                  }
                                </>
                              } */}
                              </div>
                            </div>
                          </Col>

                        </Row>
                      </AutosaveReport>
                    </>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </Container>
      </section >
    </>
  );
};

export default ClassroomReport;